<template>
  <el-dropdown :show-timeout="100" trigger="click" @command="handleCommand" :style="style">
    <div class="three-dots-vertical"><svg-icon icon-class="threeDotsVertical" /></div>
    <el-dropdown-menu slot="dropdown">
      <slot />
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  props: {
    height: {type: Number, default: 30}
  },
  computed: {
    style () {
      const style = {}
      if (this.height) {
        style.height = `${this.height}px`
      }
      return style
    }
  },
  methods: {
    handleCommand (command, item) {
      this.$emit('command', arguments)
      item.$emit.apply(item, ['click'].concat(command));
    }
  }
}
</script>
<style scoped>
  .three-dots-vertical {
    cursor: pointer;
    color: #444;

    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 5px;
    width: 2rem;
    align-items: center;
  }

  .three-dots-vertical:hover {
    color: #409EFF;
    background-color: rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ThreeDotsMenu.vue